import React from 'react';
import { createSvgIcon } from '@mui/material';
export default createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 6H12L10.9725 3.85275C10.7227 3.3315 10.197 3 9.61875 3H4.13175C3.46125 3 2.87325 3.444 2.6895 4.0875L1.5 8.25V19.5C1.5 20.328 2.172 21 3 21H21C21.828 21 22.5 20.328 22.5 19.5V7.5C22.5 6.672 21.828 6 21 6Z" // eslint-disable-line
 }), 'FolderFilled');
